import { generateUtilityClass, generateUtilityClasses } from "@mui/material";
const actionHeaderName = "TidalActionHeader";
function getActionHeaderUtilityClass(slot) {
  return generateUtilityClass(actionHeaderName, slot);
}
const actionHeaderClasses = generateUtilityClasses(actionHeaderName, [
  "root",
  "expanded",
  "padded",
  "sizeTiny",
  "sizeSmall",
  "sizeMedium",
  "sizeLarge",
  "hideIcon",
  "title",
  "titleSizeTiny",
  "titleSizeSmall",
  "titleSizeMedium",
  "titleSizeLarge",
  "titleClickable",
  "chevron",
  "subtitle",
  "subtitleSizeTiny",
  "subtitleSizeSmall",
  "subtitleSizeMedium",
  "subtitleSizeLarge",
  "primaryAction",
  "primaryActionHover",
  "secondaryAction",
  "secondaryActionHover"
]);
export {
  actionHeaderClasses,
  actionHeaderName,
  getActionHeaderUtilityClass
};
//# sourceMappingURL=classes.js.map
